import React from 'react';
import moment from 'moment';
import { Text } from '@upsales/components';

export const SubTitle = ({ date }) => (
	<Text size="sm" color="grey-11">
		{moment(date).format('L LT')}
	</Text>
);
